import React, { useCallback } from 'react';
import QRCode from 'react-qr-code';
import PropTypes from 'prop-types';

import { NotificationManager } from '@atlas/core';
import { BasePopup, Button, HeaderTitle, Icon, Label } from '@atlas/ui';

export default function StarsPayPopup({ data, id }) {
  const { redirectUrl, text, title } = data;
  const [isCopied, setIsCopied] = React.useState(false);

  const handleClose = useCallback(() => {
    NotificationManager.removeNotification(id);
  }, [id]);

  const buttonLabel = React.useMemo(() => (isCopied ? 'copied' : 'copy_pix'), [isCopied]);

  const copy = useCallback(
    e => {
      e.preventDefault();
      const inp = document.createElement('textarea');
      document.body.appendChild(inp);
      inp.value = redirectUrl;
      inp.select();
      document.execCommand('copy', false);
      document.body.removeChild(inp);
      setIsCopied(true);
    },
    [data, setIsCopied],
  );

  return (
    <BasePopup className="stars-pay-modal">
      <HeaderTitle className="left border block-big size-xs" title="pix_header_title">
        <div className="header-title__children">
          <button onClick={handleClose} type="button">
            <Icon name="close" />
          </button>
        </div>
      </HeaderTitle>

      <div className="popup__content">
        <Label className="popup__title" message={title} />
        <Label className="popup__text" message={text} />

        <div className="stars-pay-modal__qr">
          <QRCode size={130} value={redirectUrl} />
        </div>
      </div>

      <div className="popup__footer">
        <Button
          className="primary big block"
          disabled={isCopied}
          label={buttonLabel}
          onClick={copy}
        />
      </div>
    </BasePopup>
  );
}

StarsPayPopup.propTypes = {
  data: PropTypes.shape({
    redirectUrl: PropTypes.string,
    text: PropTypes.string,
    title: PropTypes.string,
  }).isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
